"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListerPaginationContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_redux_1 = require("react-redux");
const ListerSelector_1 = require("../../redux/lister/selectors/ListerSelector");
const ListerPagination_1 = require("../../components/lister/ListerPagination");
const ListerPaginationContainer = () => {
    const totalPages = (0, react_redux_1.useSelector)((0, ListerSelector_1.makeGetTotalPages)());
    return (0, jsx_runtime_1.jsx)(ListerPagination_1.ListerPagination, { updateCanonicalLinkElement: false, totalPages: totalPages });
};
exports.ListerPaginationContainer = ListerPaginationContainer;
